import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

class ItemHistoryListService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      items: [],
    });
  }

  handleLoad = action((itemId) => {
    this.fetch
      .fetch({
        url: `/items/${itemId}/history`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.items = this.fetch.data.map((item, index) => ({
            ...item,
            version: index + 1,
            isCurrent: index + 1 === this.fetch.data.length,
          }));
        }
      });
  });
}

export default ItemHistoryListService;
